import { render } from "./SelectCurrency.vue?vue&type=template&id=0fa940b4&scoped=true"
import script from "./SelectCurrency.vue?vue&type=script&lang=js"
export * from "./SelectCurrency.vue?vue&type=script&lang=js"

import "./SelectCurrency.vue?vue&type=style&index=0&id=0fa940b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa940b4"]])

export default __exports__